/*eslint-disable */

import "pdf-annotate-vue/src/css/toolbar.css";
import "pdf-annotate-vue/src/css/pdf_viewer.css";

import PdfAnnotate from 'pdf-annotate-vue';
import axios from 'axios';
import {bus} from '@/main';
import root from '@/_helpers/roots';

let saveAnnotationApiUrl = root.saveAnnotationApiUrl.link;

export default {
  name: 'pdf-render-annotation',
  components: {
    PdfAnnotate
  },
  props: ['PDFurl', 'pdfId'],
  data () {
    return {
      pdf: this.PDFurl,
      toolbar:true,
      pdfLoaded:false,
      pdfViewerOptions: {
        scale: 1.5, // Set the default scale to 1.5
      },
    }
  },
  computed: {

  },
  mounted () {
    this.onPdfLoaded();
    bus.$on('appliedAnnotationChangesEmit', (data) => {
      this.saveAnnotations();
    })
  },
  methods: {
    onPdfLoaded() {
      this.pdfLoaded = true;
      axios.get(saveAnnotationApiUrl + '?paper_id=' + this.pdfId).then((res) => {
        const savedAnnotations = res.data.data.result.annotation_data;
        if(savedAnnotations){
          localStorage.setItem(`${this.PDFurl}/annotations`,  savedAnnotations);
        }
      })
    },
    saveAnnotations() {
      if (!this.pdfLoaded) {
        console.error('PDF document has not finished loading!');
        return;
      }
      const pdfViewer = this.$refs.pdfViewer;
      if(pdfViewer){
        // To get annotations:
        let annotations = localStorage.getItem(`${this.PDFurl}/annotations`);
        const requestBody = {
          paper_id: this.pdfId,
          annotation_data:annotations,
        }
        axios.post(saveAnnotationApiUrl, requestBody).then((res) => {
        }).catch((err) => {
        })
      }else{
        console.error('pdfViewer component reference is null');
      }
    },
  }
}